import * as actionTypes from "../actionTypes";
import gql from "graphql-tag"
import ReactHtmlParser from "react-html-parser";
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import Config from "../../../config/config";
import Messages, { INotificationError, NotificationErrTypes } from "../../../helper/messages";
import {
	CognitoUserAttribute,
	CognitoUserPool,
} from "amazon-cognito-identity-js";
import * as ImmersionGQL from "../../../gql";

//set loader
export const setLoading = (loading: boolean) => ({
	type: actionTypes.SET_LOADING,
	payload: loading
});

export const setExpLoading = (value: any) => ({
	type: actionTypes.SET_EXPERIENCE_LOADING,
	payload: value,
  });

//Get all Billing Detail
const getBillingDetail = (items: any) => ({
	type: actionTypes.GET_BILLING_DETAILS,
	payload: items
});

//Get all admin users
const getUserList = (items: any) => ({
	type: actionTypes.GET_ALL_USERS,
	payload: items
});

//Get all admin roles
const getRoleList = (items: any) => ({
	type: actionTypes.GET_ALL_ADMIN_ROLES,
	payload: items
});

const getUserDetailSuccess = (items: any) => ({
	type: actionTypes.GET_ADMIN_USER_DETAILS,
	payload: items
});

const trailheader = (value: any) => ({
	type: actionTypes.TRIAL_HEADER,
	payload: value
});

 
// fail notification
export const notificationFail = (err: any, errormessage: any) => {
	let msg = Messages.NOTIFICATIONS.ERROR.someThingWrong
	if (errormessage) {
		msg = errormessage
	}
	if (err.graphQLErrors && err.graphQLErrors.length > 0) {
		msg = err.graphQLErrors[0].message;
	} else if (err.message) {
		msg = err.message;
	}
	store.addNotification({
		title: "Error!",
		message: <p>{ReactHtmlParser(msg)}</p>,
		type: "danger",
		insert: "bottom",
		container: "bottom-center",
		animationIn: ["animate__animated", "animate__fadeIn"],
		animationOut: ["animate__animated", "animate__fadeOut"],
		dismiss: {
			duration: 8000,
			onScreen: true
		}
	})
	return {
		type: actionTypes.ADD_NEW_NOTIFICATION_FAIL,
		state: msg
	}
}

// success notification without dispath
export const displaySuccessMessage = (message: any) => {
  if (message) {
    store.addNotification({
      title: "Success!",
      message: message,
      type: "success",
      insert: "bottom",
      container: "bottom-center",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true
      }
    })
  }
  return {
    type: actionTypes.ADD_NEW_NOTIFICATION_SUCCESS,
    state: message
  }
}

export const addUser = (client: any, request: any) => {
	return async (dispatch: any) => {
		const poolData = {
			UserPoolId: Config.CONFIG.USER_POOL, // Your user pool id here
			ClientId: Config.CONFIG.CLIENT_ID, // Your client id here
		};
		const userPool: any = new CognitoUserPool(poolData);
		const attributeList = [];
		const dataEmail = {
			Name: "email",
			Value: request.username.toLowerCase().trim(),
		};
		const dataFirstName = {
			Name: "given_name",
			Value: request.fname,
		};
		const dataLastName = {
			Name: "family_name",
			Value: request.lname,
		};
		const dataMiddleName = {
			Name: "middle_name",
			Value: "",
		};
		const dataName = {
			Name: "name",
			Value: request.display_name,
		};
		const tenantName = {
			Name: "custom:tenantname",
			Value: request.customername,
		};

		const attributeEmail = new CognitoUserAttribute(dataEmail);
		const attributeFirstname = new CognitoUserAttribute(dataFirstName);
		const attributeLastname = new CognitoUserAttribute(dataLastName);
		const attributeMiddlename = new CognitoUserAttribute(dataMiddleName);
		const attributeName = new CognitoUserAttribute(dataName);
		const attributeTenantName = new CognitoUserAttribute(tenantName);

		attributeList.push(attributeEmail);
		attributeList.push(attributeFirstname);
		attributeList.push(attributeLastname);
		attributeList.push(attributeMiddlename);
		attributeList.push(attributeName);
		attributeList.push(attributeTenantName);

		userPool.signUp(
			request.username.toLowerCase().trim(),
			"TenantAccountP@ssword1!!",
			attributeList,
			null,
			function (err: any) {
				if (err) {
					if (err.code === "UsernameExistsException") {
						dispatch(notificationFail({}, err.message))
					} else {

					}
				} else {
					const mutation = gql`
						mutation signup($middlename: String, $display: String!, $customername: String!, $lastname: String!, $firstname: String!, $username: String!, $systemflag: Boolean, $department_id:Float, $admin_role_name: String, $adminemail: Boolean, $prepaid: Boolean, $billing_subscription_id: String ) {
							signup(middlename: $middlename, display: $display, customername: $customername, lastname: $lastname, firstname: $firstname, username: $username, systemflag: $systemflag, department_id: $department_id, admin_role_name: $admin_role_name, adminemail: $adminemail, prepaid: $prepaid, billing_subscription_id: $billing_subscription_id) {
									status
									message
									data
									messagecode
								}
							}
						`;
					const variables = { ...request, username: request.username.toLowerCase().trim()};
					dispatch(setLoading(true));
					client.mutate({
						mutation: mutation,
						fetchPolicy: "no-cache",
						variables
					}).then((response: any) => {
						if (response.data.signup.status === "true") {
							const requestData = { customer_name: request.customername }
							dispatch(getAdminUsers(client, requestData))
						} else {
							let message: string = Messages.NOTIFICATIONS.ERROR.saveUserFail
							const notificationError: INotificationError = Messages.NOTIFICATIONS.ERROR;
							const messagecode: NotificationErrTypes = response.data.signup.messagecode;
							if (messagecode && notificationError[messagecode]) {
								message = notificationError[messagecode]
							} else {
								if (response.data.signup.message) {
									message = response.data.signup.message
								}
							}
							dispatch(notificationFail({}, message))
						}
						dispatch(setLoading(false));
					}).catch(() => {
						dispatch(notificationFail({}, Messages.NOTIFICATIONS.ERROR.saveUserFail))
					});
				}
			}
		)
	};
};


//Get 
export const getBillingDetails = (client: any, req: any) => {
	return (dispatch: any) => {
		dispatch(setLoading(true));
		const variables = { ...req };
		client.query({
			query: ImmersionGQL.queryGetBillingDetails,
			fetchPolicy: "no-cache",
			variables
		})
		.then((res: any) => {
			if (res.data.getBillingDetails) {
				dispatch(getBillingDetail(res.data.getBillingDetails));
			} else {
				dispatch(notificationFail({}, res.data.getBillingDetails.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {

		})
	}
};


//Get all admin user
export const getAdminUsers = (client: any, req: any) => {
	return (dispatch: any) => {
		dispatch(setExpLoading(true));
		const variables = { ...req };
		client.query({
			query: ImmersionGQL.queryGetAdminUsers,
			fetchPolicy: "no-cache",
			variables
		})
		.then((res: any) => {
			if (res.data.getAdminUsers) {
				dispatch(getUserList(res.data.getAdminUsers));
				dispatch(setExpLoading(false));
			} else {
				dispatch(notificationFail({}, res.data.getAdminUsers.message))
				dispatch(setExpLoading(false));
			}
			
		}).catch(() => {
			dispatch(setExpLoading(false));
		})
	}
};

// edit admin user
export const editUser = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationEditUser,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.editUser.status === "true") {
				const request = { customer_name: req.customer_name }
				dispatch(getAdminUsers(client, request))
			} else {
				dispatch(notificationFail({}, req.data.editUser.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};
// delete admin user
export const deletePermanentUser = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationDeletePermanentUser,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.deletePermanentUser.status === "true") {
				displaySuccessMessage(res.data.deletePermanentUser.message)
				const request = { customer_name: req.customer_name }
				dispatch(getAdminUsers(client, request))
			} else {
				dispatch(notificationFail({}, req.data.deletePermanentUser.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

//Get all admin role
export const getRoles = (client: any, req: any) => {
	return (dispatch: any) => {
		dispatch(setLoading(true));
		const variables = { ...req };
		client.query({
			query: ImmersionGQL.queryGetRoleList,
			fetchPolicy: "no-cache",
			variables
		})
		.then((res: any) => {
			if (res.data.getRoleList) {
				dispatch(getRoleList(res.data.getRoleList));
			} else {
				dispatch(notificationFail({}, res.data.getRoleList.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {

		})
	}
};


// Change role status
export const updateUserStatus = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationUpdateUserStatus,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.updateUserStatus.status === "true") {
				const request = { customer_name: req.customer_name }
				dispatch(getAdminUsers(client, request))
			} else {
				dispatch(notificationFail({}, req.data.updateUserStatus.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

// Update MFA status
export const updateUserMFAStatus = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationUpdateMfa,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.udpateMfa.status === "true") {
				const request = { customer_name: req.customer_name }
				dispatch(getAdminUsers(client, request))
			} else {
				dispatch(notificationFail({}, req.data.udpateMfa.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

// Update User Role
export const getUserDetails = (client: any, req: any) => {
	return (dispatch: any) => {
		dispatch(setLoading(true));
		const variables = { ...req };
		client.query({
			query: ImmersionGQL.queryGetUserDetails,
			fetchPolicy: "no-cache",
			variables
		})
			.then((res: any) => {
				if (res.data.getUserDetails) {
					dispatch(getUserDetailSuccess(res.data.getUserDetails));
				} else {
					dispatch(notificationFail({}, res.data.getUserDetails.message))
				}
				dispatch(setLoading(false));
			}).catch(() => {

			})
	}
};

// Update MFA status
export const updateUserRoles = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationChangeUserRoles,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.changeUserRoles.status === "true") {
				const request = { customer_name: req.customer_name }
				dispatch(getAdminUsers(client, request))
			} else {
				dispatch(notificationFail({}, req.data.changeUserRoles.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

// Reset user password
export const resetUserPassword = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req, email: req.email.toLowerCase().trim() };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationResetUserPassword,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.resetUserPassword.status === "false") {
				let message = Messages.NOTIFICATIONS.ERROR.resetPasswordFail
				if (res.data.resetUserPassword.message) {
					message = res.data.resetUserPassword.message
				}
				dispatch(notificationFail({}, message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

//Get all stripe products and plan list
const stripeProductList = (items: any) => ({
	type: actionTypes.GET_STRIPE_PRODUCT_LIST,
	payload: items
});

export const getStripeProductsList = (client: any) => {
	return (dispatch: any) => {
		dispatch(setLoading(true));
		client.query({
			query: ImmersionGQL.getStripeProductsList,
			fetchPolicy: "no-cache",
		})
		.then((res: any) => {
			if (res.data.getStripeProductsList) {
				dispatch(stripeProductList(res.data.getStripeProductsList.data));
			} else {
				dispatch(notificationFail({}, res.data.getStripeProductsList.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {

		})
	}
};


// get charge history/other data for customer stripe
const stripeCustomerData = (items: any) => ({
	type: actionTypes.GET_STRIPE_CUSTOMER_DETAIL,
	payload: items
});
export const getStripeCustomerDetail = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationgetStripeCustomerDetail,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.getStripeCustomerDetail) {
		        dispatch(stripeCustomerData(res.data.getStripeCustomerDetail.data));
		      }
		      if (res.data.getStripeCustomerDetail.status ==="false") {
		        dispatch(notificationFail({},res.data.getStripeCustomerDetail.message))
		      }
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

// activate/deactivate user
export const userLock = (client: any, req: any) => {
	return (dispatch: any) => {
		const variables = { ...req };
		dispatch(setLoading(true));
		client.mutate({
			mutation: ImmersionGQL.mutationUserLock,
			fetchPolicy: "no-cache",
			variables
		}).then((res: any) => {
			if (res.data.userLock.status === "true") {
				displaySuccessMessage(res.data.userLock.message)
				const request = { customer_name: req.customer_name }
				dispatch(getAdminUsers(client, request))
			} else {
				dispatch(notificationFail({}, req.data.userLock.message))
			}
			dispatch(setLoading(false));
		}).catch(() => {
			// handle error
			dispatch(setLoading(false));
		})
	}
};

export const setTrailheader = (req: any) => {
	return (dispatch: any) => {
		dispatch(trailheader(req));
	}
}